export const setInitialValues = (data: any) => {
  return {
    category: data.category ? data.category : '',
    description: data.description ? data.description : '',
    unit: data.unit ? data.unit : '',
    quantity: data.quantity ? data.quantity : '',
    unitValue: data.unitValue ? data.unitValue.toFixed(2) : '',
    totalValue: data.totalValue ? data.totalValue.toFixed(2) : ''
  }
}
